import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectSidebarState = (state: RootState) => state.sidebarState;

export const selectFolderItems = createSelector(selectSidebarState, (state) => {
  return state.folderItems;
});

export const selectRagObjects = createSelector(selectSidebarState, (state) => {
  return state.ragObjects;
});

export const selectLoading = createSelector(selectSidebarState, (state) => {
  return state.isLoading;
});

export const selectRagObjectsAsMenuItems = createSelector(
  selectSidebarState,
  (state) =>
    state.ragObjects
      .filter((item) => item.value !== null)
      .map((item) => ({
        id: String(item.id),
        name: item.friendly_name,
      }))
);
